module.exports = __webpack_public_path__ + "img/share-desc.de0924d5.png";